<template>
  <AwModal
    :open="open"
    title="Pour quelle raison souhaites-tu refuser ce document ?"
    size="md"
    @update:open="handleOpen"
  >
    <template #body>
      <div class="flex flex-col gap-4 p-4">
        <AwFormField label="Motif du refus :" required>
          <AwTextarea
            class="w-full"
            placeholder="Ex : Document illisible, informations manquantes, date d'expiration dépassée..."
            :model-value="rejectionReason"
            :disabled="isRejecting"
            @update:model-value="handleRejectionReasonUpdate"
          />
        </AwFormField>

        <AwBanner color="primary" icon="i-ph-info" text="Le motif de refus sera visible par l'intérimaire." />
      </div>
    </template>

    <template #footer>
      <AwButton color="secondary" variant="outline" :disabled="isRejecting" @click="handleCancel">Annuler</AwButton>
      <AwButton color="critical" :disabled="!canConfirm" :loading="isRejecting" @click="handleConfirm">
        Refuser le document
      </AwButton>
    </template>
  </AwModal>
</template>

<script setup lang="ts">
import { AwFormField, AwTextarea } from "@asap/design";

type Props = {
  open: boolean;
  isRejecting?: boolean;
};

type Emits = {
  "update:open": [value: boolean];
  cancel: [];
  confirm: [reason: string];
};

const props = withDefaults(defineProps<Props>(), {
  isRejecting: false,
});
const emit = defineEmits<Emits>();

const rejectionReason = ref("");

const canConfirm = computed(() => rejectionReason.value.trim().length > 0 && !props.isRejecting);

const handleRejectionReasonUpdate = (value: string | undefined) => {
  rejectionReason.value = value ?? "";
};

const handleOpen = (value: boolean) => {
  if (!value) handleCancel();
};

const handleCancel = () => {
  if (props.isRejecting) return;
  emit("update:open", false);
  emit("cancel");
};

const handleConfirm = () => {
  if (!canConfirm.value) return;
  emit("confirm", rejectionReason.value.trim());
};
</script>
